import { debug } from "../utils";

export const ACTION_LICENSE_LOADED = "ACTION_LICENSE_LOADED";
export const ACTION_MACHINE_DATA_LOADED = "ACTION_MACHINE_DATA_LOADED";

export function LicensePageReducer(state = {}, action) {
    switch (action.type) {
        case ACTION_LICENSE_LOADED: {
            debug(`LicensePageReducer ${ACTION_LICENSE_LOADED} is being processed...`)
            return { ...state, ...action.payload };
        }
        case ACTION_MACHINE_DATA_LOADED: {
            debug(`LicensePageReducer ${ACTION_MACHINE_DATA_LOADED} is being processed...`)
            return { ...state, ...action.payload };
        }
        default:
            return state;
    }
}